var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5V7.5H4.5V4.5H7.5ZM9 3H3V9H9V3ZM7.5 12.5V15.5H4.5V12.5H7.5ZM9 11H3V17H9V11ZM15.5 4.5V7.5H12.5V4.5H15.5ZM17 3H11V9H17V3ZM11 11H12.5V12.5H11V11ZM12.5 12.5H14V14H12.5V12.5ZM14 11H15.5V12.5H14V11ZM11 14H12.5V15.5H11V14ZM12.5 15.5H14V17H12.5V15.5ZM14 14H15.5V15.5H14V14ZM15.5 12.5H17V14H15.5V12.5ZM15.5 15.5H17V17H15.5V15.5ZM19 5C18.45 5 18 4.55 18 4V2H16C15.45 2 15 1.55 15 1C15 0.45 15.45 0 16 0H19C19.55 0 20 0.45 20 1V4C20 4.55 19.55 5 19 5ZM20 19V16C20 15.45 19.55 15 19 15C18.45 15 18 15.45 18 16V18H16C15.45 18 15 18.45 15 19C15 19.55 15.45 20 16 20H19C19.55 20 20 19.55 20 19ZM1 20H4C4.55 20 5 19.55 5 19C5 18.45 4.55 18 4 18H2V16C2 15.45 1.55 15 1 15C0.45 15 0 15.45 0 16V19C0 19.55 0.45 20 1 20ZM0 1V4C0 4.55 0.45 5 1 5C1.55 5 2 4.55 2 4V2H4C4.55 2 5 1.55 5 1C5 0.45 4.55 0 4 0H1C0.45 0 0 0.45 0 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialSetup);
export default __webpack_public_path__ + "static/media/initial_setup.c6619099cc5e5495969345dd5b92677f.svg";
export { ForwardRef as ReactComponent };